import React from 'react';
import { Box, Button, Menu, Text, createStyles } from "@mantine/core";
import filter from "../assets/img/filter.svg"
import { ReactComponent as Ehr } from "../assets/img/Ehr.svg";
import { ReactComponent as Wear } from "../assets/img/Wear.svg";
import { ReactComponent as List } from "../assets/img/list.svg";

import { useNavigate } from 'react-router-dom';
const useStyles = createStyles(() => ({
  item1: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "246px",
    height: "56px",
  },
  div1: {
    display: "flex",
    alignItems: "center",
    marginRight: "0.5rem",
    marginLeft: "30px",
    flexWrap: "wrap",
    minWidth: "min-content",
  },
  span: {
    fontSize: "14px",
    color: "#474E5B",
    fontWeight: 600,
    lineHeight: "21px",
    marginLeft: "16px",
  },
  box1: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  menu1: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "156px",
    height: "56px",
  },
  menu2: {
    display: "flex",
    alignItems: "center",
    marginRight: "0.5rem",
    marginLeft: "30px",
    flexWrap: "wrap",
    minWidth: "min-content",
  },
  span2: {
    fontSize: "14px",
    color: "#474E5B",
    fontWeight: 600,
    lineHeight: "21px",
    marginLeft: "16px",
  },
  text: {
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#262930",
    width: "268px",
    height: "56px",
    display: "flex",
    alignItems: "center",
    padding: "8px",
    paddingLeft: "38px",
  },
  dropdown: {
    position: "absolute",
    minWidth: "256px",
    right: 0,
    transform: "translateX(calc(100% - 309px))",
  },
}));

interface Props {
  name: string;
  button:any
  clickEhr:any;
  clickWear:any;
  clickAll:any
}

const Layout: React.FC<Props> = ({ name, button,clickWear,clickEhr,clickAll}) => {

  const MenuItemWithIcon = ({

    icon,
    text,
    onClick,
    rightSection,
    color,
  }: {
    icon: React.ReactNode;
    text: string;
    onClick: () => void;
    rightSection?: React.ReactNode;
    color?: string;
  }) => {
      const { classes } = useStyles();

    return (
      <Menu.Item
        color={color}
        className={classes.item1}
        onClick={onClick}
      >
        <div
         className={classes.div1}
        >
          {icon}
          <span
           className={classes.span}
          >
            {text}
          </span>
        </div>{" "}
        {rightSection && (
          <span style={{ marginLeft: "auto" }}>{rightSection}</span>
        )}
      </Menu.Item>
    );
  };
  const navigate=useNavigate()
      const { classes } = useStyles();

  

  return (
    <Box sx={{}}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Text
          sx={{
            fontWeight: 600,
            fontSize: "22px",
            lineHeight: "30px",
            color: "#262930",
          }}
        >
          {name}
        </Text>
        <Box sx={{ cursor: "pointer" }}>
          <Menu shadow="md" width={"256px"}>
            <Menu.Target>
              <img src={button} />
            </Menu.Target>

            <Menu.Dropdown className={classes.dropdown}>
              <Menu.Label>
                <Text className={classes.text}>Select Filter Type</Text>
              </Menu.Label>

              <Menu.Divider />
              <MenuItemWithIcon
                icon={<Ehr />}
                text="EHR Connect"
                onClick={clickEhr}
              />
              <Menu.Divider />
              <MenuItemWithIcon
                icon={<Wear />}
                text="Wear Connect"
                onClick={clickWear}
              />
              <Menu.Divider />
              <MenuItemWithIcon
                icon={<List/>}
                text="Show All"
                onClick={clickAll}
              />
            </Menu.Dropdown>
          </Menu>
        </Box>
      </Box>
      <Box sx={{ marginTop: "16px" }}></Box>
    </Box>
  );
}
const MenuItemWithIcon = ({
  icon,
  text,
  onClick,
  rightSection,
  color,
}: {
  icon: React.ReactNode;
  text: string;
  onClick: () => void;
  rightSection?: React.ReactNode;
  color?: string;
}) => {
        const { classes } = useStyles();

  return (
    <Menu.Item
      color={color}
    className={classes.menu1}
      onClick={onClick}
    >
      <div
        className={classes.menu2}
      >
        {icon}
        <span
         className={classes.span2}
        >
          {text}
        </span>
      </div>{" "}
      {rightSection && (
        <span style={{ marginLeft: "auto" }}>{rightSection}</span>
      )}
    </Menu.Item>
  );
};


export default Layout;
